import { Tab, Tabs } from "@mui/material";
import type { FC } from "react";

type Props = {
	value: number;
	onChange: (event: React.SyntheticEvent, newValue: number) => void;
	tabs: { id: string; label: string }[];
};

export const MyPlannTabsRedesign: FC<Props> = ({ value, onChange, tabs }) => (
	<Tabs redesigned value={value} onChange={onChange} variant="fullWidth">
		{tabs.map((tab) => (
			<Tab redesigned key={tab.id} label={tab.label} disableRipple />
		))}
	</Tabs>
);
